import React, { useState, useEffect, useRef ,useContext} from 'react';
import { useCurrency } from '../../Shared/CurrencyContext';
import { useTranslateKey } from "../../translation/useTranslateKey";
import { LangContext } from "../../translation/langugeContext";

function Currency({ pageData }) {
  //console.log("Full pageData:", pageData);
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const {currency,setCurrency}=useCurrency()
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);

const flagMap = {
        EGP: "eg",
        USD: "us",
        EUR: "eu",
        SAR: "sa",
        AED: "ae",
        KWD: "kw", 
        QAR: "qa",
        BHD: "bh",
      };
      //console.log("pageData.currencies:", pageData?.currencies);
      const currencies = (pageData?.currencies || []).map((currency) => {
      return { ...currency ,flag: flagMap[currency.code] || "eg" };
});

  const toggleCurrencyDropdown = () => {
    setShowCurrencyDropdown(!showCurrencyDropdown);
  };

  // close list on click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowCurrencyDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  return (
    <div className="w-[150px]  text-white relative" ref={dropdownRef}>
      <button
        type="button"
        className="currency-toggle group flex items-center justify-between w-full text-sm py-1.5 pl-2 pr-3 bg-[#11132F] border border-[#332D7E] rounded-lg"
        onClick={toggleCurrencyDropdown}
      >
        <span className="selected-currency flex items-center gap-2">
          <span
            className={`fi fi-${currency.flag} transition-transform duration-300 ease-in-out transform hover:scale-110 hover:rotate-6`}
            style={{
              fontSize: "18px",
              width: "35px",
              height: "35px",
              borderRadius: "9999px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          ></span>
        </span>
        {/* tooltip */}
         <div
        style={{ backgroundColor: "#11132F", width: "110px" , top: "47px"}}
        className="absolute left-1/2 -translate-x-1/2  text-white text-xs px-3 py-1 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50"
      >
        {t("selectCurrency")}
      </div>
      </button>

      {/* currency list*/}
      <div
        className={`currency-options ${
          showCurrencyDropdown ? "block" : "hidden"
        } absolute top-full left-0 w-full mt-1 bg-[#11132F] border border-[#332D7E] rounded-lg z-[60]`}
      >
        {currencies.map((currency) => (
          <div
            key={currency.code}
            className="currency-option p-2 hover:bg-[#332D7E] cursor-pointer flex items-center gap-2"
            onClick={() => {setCurrency(currency);setShowCurrencyDropdown(false);}}
          >
            <span
              className={`fi fi-${currency.flag}`}
              style={{
                fontSize: "24px",
                lineHeight: "1",
                display: "inline-block",
                width: "24px",
                height: "16px",
              }}
            ></span>
            {currency.code}
            {/* {lang === "ar" ? currency.name_ar : currency.name_en} */}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Currency;
